import React from 'react';
import { Affix as AntdAffix, AffixProps } from 'antd';

const Affix: React.FunctionComponent<AffixProps> = (props: AffixProps) => {
	return <AntdAffix {...props} />;
};

export default Affix;
